(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[304],{

/***/ 40304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content018": function() { return /* binding */ Content018; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87900);
/* harmony import */ var _Content018_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20914);
/* harmony import */ var _Content018_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Content018_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var Content018 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var subTitle = (ref1 = payload === null || payload === void 0 ? void 0 : payload.subTitle) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var date = (ref2 = payload === null || payload === void 0 ? void 0 : payload.date) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    var description = (ref3 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref3 !== void 0 ? ref3 : "";
    var ref4;
    var image = (ref4 = payload === null || payload === void 0 ? void 0 : payload.preview) !== null && ref4 !== void 0 ? ref4 : {};
    var ref5;
    var appearance = (ref5 = payload === null || payload === void 0 ? void 0 : payload.template) !== null && ref5 !== void 0 ? ref5 : "light";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Content018_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper), (_Content018_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[appearance]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            className: (_Content018_module_scss__WEBPACK_IMPORTED_MODULE_3___default().inner),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Content018_module_scss__WEBPACK_IMPORTED_MODULE_3___default().block),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Content018_module_scss__WEBPACK_IMPORTED_MODULE_3___default().content),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading3 */ .aC, {
                                className: (_Content018_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Paragraph */ .nv, {
                                className: (_Content018_module_scss__WEBPACK_IMPORTED_MODULE_3___default().date),
                                color: "brand",
                                children: date
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading5 */ .by, {
                                className: (_Content018_module_scss__WEBPACK_IMPORTED_MODULE_3___default().subtitle),
                                children: subTitle
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Paragraph */ .nv, {
                                className: (_Content018_module_scss__WEBPACK_IMPORTED_MODULE_3___default().description),
                                color: "dark",
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Content018_module_scss__WEBPACK_IMPORTED_MODULE_3___default().preview),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .ImageLite */ .NH, {
                            image: image,
                            className: (_Content018_module_scss__WEBPACK_IMPORTED_MODULE_3___default().image)
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content018);


/***/ }),

/***/ 20914:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content018_wrapper__B5jDg","light":"Content018_light__cxrYV","grey":"Content018_grey__LZ8_D","block":"Content018_block__sEo5A","content":"Content018_content__hzM_q","preview":"Content018_preview__NIY0i","title":"Content018_title__NPTev","subtitle":"Content018_subtitle__rMRQj","description":"Content018_description__6hdQV","date":"Content018_date__9iaD8","image":"Content018_image__ICQKx"};

/***/ })

}]);